import React from 'react';
import './ColorFilter.css';

export const COLOR_OPTIONS = [
  { key: 'white',  label: 'White',  swatch: '#f4f2f0', border: '#d0ccc8' },
  { key: 'ivory',  label: 'Ivory',  swatch: '#ede0ca', border: '#ccc0aa' },
  { key: 'beige',  label: 'Beige',  swatch: '#d4c4a0', border: '#b8a888' },
  { key: 'grey',   label: 'Grey',   swatch: '#909090', border: '#707070' },
  { key: 'silver', label: 'Silver', swatch: '#b8bcc0', border: '#9898a0' },
  { key: 'black',  label: 'Black',  swatch: '#222222', border: '#000000' },
  { key: 'brown',  label: 'Brown',  swatch: '#8b5e3c', border: '#6a4428' },
  { key: 'gold',   label: 'Gold',   swatch: '#c9a84c', border: '#a88830' },
  { key: 'green',  label: 'Green',  swatch: '#4a7a60', border: '#306048' },
  { key: 'teal',   label: 'Teal',   swatch: '#3a8a88', border: '#226866' },
  { key: 'blue',   label: 'Blue',   swatch: '#4a6888', border: '#304868' },
];

export default function ColorFilter({ activeColors, onToggle }) {
  return (
    <div className="color-filter">
      <span className="color-filter__label">Color:</span>
      <div className="color-filter__swatches">
        {COLOR_OPTIONS.map(({ key, label, swatch, border }) => {
          const active = activeColors.includes(key);
          return (
            <button
              key={key}
              className={`color-swatch${active ? ' color-swatch--active' : ''}`}
              onClick={() => onToggle(key)}
              title={label}
              aria-label={`${active ? 'Remove' : 'Add'} ${label} filter`}
              aria-pressed={active}
            >
              <span
                className="color-swatch__circle"
                style={{ background: swatch, borderColor: border }}
              />
              <span className="color-swatch__label">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
